import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  const rows = [
    { label: t('comparison.row1_label'), yes: t('comparison.row1_yes'), no: t('comparison.row1_no') },
    { label: t('comparison.row2_label'), yes: t('comparison.row2_yes'), no: t('comparison.row2_no') },
    { label: t('comparison.row3_label'), yes: t('comparison.row3_yes'), no: t('comparison.row3_no') },
    { label: t('comparison.row4_label'), yes: t('comparison.row4_yes'), no: t('comparison.row4_no') },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-white">
      <div className="max-w-[900px] mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center tracking-tight">
          {t('comparison.title')}
        </h2>

        <div className="mt-12 bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="text-left py-4 px-6 font-label text-xs uppercase text-foreground-500 tracking-wider">Параметр</th>
                <th className="text-center py-4 px-6 font-label text-xs uppercase text-foreground-950 tracking-wider font-semibold">{t('comparison.col1')}</th>
                <th className="text-center py-4 px-6 font-label text-xs uppercase text-foreground-500 tracking-wider">{t('comparison.col2')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx} className="border-b border-background-100 last:border-0">
                  <td className="py-4 px-6 text-foreground-800 font-medium">{row.label}</td>
                  <td className="py-4 px-6 text-center">
                    <span className="inline-flex items-center gap-1.5 text-accent-600 font-medium">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-fill text-sm"></i>
                      </span>
                      {row.yes}
                    </span>
                  </td>
                  <td className="py-4 px-6 text-center text-foreground-500">{row.no}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-foreground-500 mb-4">{t('related.title')}</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <span className="px-4 py-2 bg-secondary-100 text-secondary-800 rounded-full text-xs font-medium">{t('related.kakobuy')}</span>
            <span className="px-4 py-2 bg-secondary-100 text-secondary-800 rounded-full text-xs font-medium">{t('related.superbuy')}</span>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 bg-primary-500 text-white rounded-full text-xs font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('related.cta')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}